module.exports = __webpack_public_path__ + "770c3c20801061dce0cab0f3e702d390.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/normal.png
// module id = 1789
// module chunks = 0